import { createSelector } from 'reselect';
import { SelectedCustomerSelector } from './customer.selectors';
export var IsExecutingBillRunSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.demoActions.isExecutingBillRun;
});
export var IsExecutingSimulateUsage = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.demoActions.isExecutingSimulateUsage;
});
export var IsRetrievingActiveWorkflowsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.demoActions.isRetrievingActiveWorkflows;
});
export var IsCompletingWorkflowSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.demoActions.isCompletingWorkflow;
});
export var ActiveWorkflowsSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.demoActions.activeWorkflows;
});